/* global axios */
import ApiClient from '../ApiClient';

class AiFocusInboxes extends ApiClient {
  constructor() {
    super('aifocus/agents', { accountScoped: true });
  }

  get({ agentId } = {}) {
    return axios.get(`${this.url}/${agentId}/inboxes`);
  }

  create(params = {}) {
    const { agentId, inboxId } = params;
    return axios.post(`${this.url}/${agentId}/inboxes`, {
      inbox: { inbox_id: inboxId },
    });
  }

  delete(params = {}) {
    const { agentId, inboxId } = params;
    return axios.delete(`${this.url}/${agentId}/inboxes/${inboxId}`);
  }
}

export default new AiFocusInboxes();
